import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'handle-connectivity',
  template: `
    @if (isOffline) {
      <ng-content select="[offline]"></ng-content>
    }
    @if (!isOffline) {
      <ng-content select="[online]"></ng-content>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HandleConnectivityComponent implements OnInit {
  isOffline = false;

  ngOnInit() {
    this.isOffline = !navigator.onLine;
  }

  @HostListener('window:offline')
  setNetworkOffline(): void {
    this.isOffline = true;
  }

  @HostListener('window:online')
  setNetworkOnline(): void {
    this.isOffline = false;
  }
}
